export default __webpack_public_path__ + "static/chat-a689c61a7d9842aa432ab178284532f9.png";